export default __webpack_public_path__ + "static/media/logo-white.ccab03c2.svg";